export {
  ALERT_TYPES,
  AOJS,
  APPEAL_TYPES,
  CHAMPVA_PROVIDERS,
  DICClaimTypeCodes,
  DOCKET_TYPES,
  EVENT_TYPES,
  ISSUE_STATUS,
  STATUS_TYPES,
  addOrRemoveDependentClaimTypeCodes,
  appealTypes,
  appealsAvailability,
  claimsAvailability,
  disabilityCompensationClaimTypeCodes,
  pensionClaimTypeCodes,
  programAreaMap,
  survivorsPensionClaimTypeCodes,
  veteransPensionClaimTypeCodes,
} from './constants';

export {
  buildDateFormatter,
  buildSafeDateFormatter,
  claimAvailable,
  claimDetailHref,
  formatDate,
  generateClaimTitle,
  generateServerClaimTitle,
  getAojDescription,
  getAppealStatusTitle,
  getClaimPhaseTypeHeaderText,
  getClaimType,
  getDocketName,
  getFailedSubmissionsWithinLast30Days,
  getHearingType,
  getListItemLabel,
  getShowEightPhases,
  getStatusDescription,
  getTypeName,
  groupClaimsByDocsNeeded,
  isChampvaProviderClaim,
  isClosed,
  isDisabilityCompensationClaim,
  isEightStepPensionClaim,
  sentenceCase,
  shouldUseClaimStatusMeta,
  sortByLastUpdated,
  withClaimStatusMetaIfEnabled,
} from './utils';

// ClaimOrAppealCard is intentionally NOT re-exported from this barrel.
// Its module imports a stylesheet, which the Cypress test bundler (esbuild
// preprocessor) does not have a loader for. Re-exporting here causes any
// Cypress spec that imports a utility from this package to pull
// the SCSS in and fail to bundle. Consumers must import the card directly:
//   import { ClaimOrAppealCard } from '~/platform/shared/claims-appeals/components/ClaimOrAppealCard';
